<div class="home-container">
  <section class="home-content" *transloco="let t; read: 'home'">
    <div class="left">
      <h2>{{ t('subtitle') }}</h2>

      <h1>{{ 'app.title' | transloco }}</h1>

      <p>{{ t('intro') }}</p>

      <div class="button-container">
        @if ((isLoggedIn$ | async) === false) {
          <htx-button variant="secondary" icon="add_business" (buttonClick)="goToRegister()">
            {{ registerButtonKey | transloco }}
          </htx-button>
        }
        <htx-button variant="tertiary" icon="play_circle" (buttonClick)="watchDemo()">
          {{ demoButtonKey | transloco }}
        </htx-button>
      </div>
    </div>
    <div class="right">
      <img class="image" src="assets/images/htx-home-image.png" alt="" routerLink="/" />
    </div>
  </section>
</div>
